import { Outlet } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const Layout = () => {
  const navbarRef = useRef(null);
  const [showAppBar, setShowAppBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down, hide AppBar
        setShowAppBar(false);
      } else {
        // Scrolling up, show AppBar
        setShowAppBar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      <Navbar />

      <div>
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Layout;
